import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdditionalServicesState } from './additional-services.reducer';
import { AditionalService } from 'src/app/pages/orders/interfaces/additionalService.interface';

export const selectAdditionalServicesState = createFeatureSelector<AdditionalServicesState>('additionalServices');

export const selectAdditionalServiceLevelResponse = createSelector(
  selectAdditionalServicesState,
  (state) => state.response,
);

export const selectAdditionalServiceWithShortDesc = createSelector(selectAdditionalServicesState, (state) => {
  const services = state.response?.value.map((service) => ({
    ...service,
    productShortDesc: service.productShortDesc ?? service.productLongDesc,
  }));
  return services as AditionalService[];
});

export const selectAdditionalServiceLevelRequest = createSelector(
  selectAdditionalServicesState,
  (state) => state.request,
);

// Cache-aware selectors keyed by normalized params
export const selectAdditionalServiceLevelByKey = (key: string) =>
  createSelector(selectAdditionalServicesState, (state) => (state.cache || {})[key] ?? null);

export const selectAdditionalServiceLevelHasDataByKey = (key: string) =>
  createSelector(selectAdditionalServicesState, (state) => !!(state.cache || {})[key]);

export const selectAdditionalServiceLevelLoading = createSelector(
  selectAdditionalServicesState,
  (state) => state.loading,
);

export const selectAdditionalServiceLevelError = createSelector(selectAdditionalServicesState, (state) => state.error);
